import { createFileRoute, useParams } from '@tanstack/react-router';

import { RubricsTab } from '@/views/admin/courses/tabs/rubrics-tab.tsx';

export const Route = createFileRoute('/admin/courses_/$id/rubrics')({
  component: RubricsRoute,
});

function RubricsRoute() {
  const { id } = useParams({ from: '/admin/courses_/$id/rubrics' });
  return <RubricsTab id={id} />;
}
